import { defineComponent, watch } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import GeotargetingIncentiveCode
	from '@/presentation/components/entities-and-geotargeting/geotargeting-incentive/geotargeting-incentive.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new GeotargetingIncentiveCode();

		watch(code.isLoading, code.prepareForLoadingGeotargeting.bind(code));

		return {
			isLoading: code.isLoading,
			isIncentiveDisabled: code.isIncentiveDisabled,
			isAnythingAttached: code.isAnythingAttached,
			isGeotargetingMicroserviceReady: code.isGeotargetingMicroserviceReady,
			availableEntities: code.availableEntities,
			attachedStudies: code.attachedStudies,
			attachedOrganisations: code.attachedOrganisations,
			hasAttachedEntityDataChanged: code.hasAttachedEntityDataChanged,
			newlyAttachedStudies: code.newlyAttachedStudies,
			newlyAttachedOrganisations: code.newlyAttachedOrganisations,
			newlyDetachedStudies: code.newlyDetachedStudies,
			newlyDetachedOrganisations: code.newlyDetachedOrganisations,
			openGeotargetingTool: code.openGeotargetingTool.bind(code)
		};
	}
});
